import { AfterViewInit, Component, Input, OnInit } from "@angular/core";
import { BreadcrumbService } from "@services/breadcrumb.service";
import { Transition } from "@uirouter/angularjs";
import { AccordianEntryComponent } from "./accordian-entry/accordian-entry.component";
import "./accordian.component.scss";

@Component({
    selector: "accordian",
    template: require("./accordian.component.html"),
})
export class AccordianComponent {
    @Input() icon: string;

    @Input() useRoute: boolean;

    // ---

    children: AccordianEntryComponent[]=[];

    registerAccordianEntry(entry: AccordianEntryComponent) {
        this.children.push(entry);
    }

    // ---

    
}
